import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as ArrowBackIcon } from "../../../assets/icons/arrow-back.svg";
import eyeSlash from "../../../assets/icons/eye-slash.svg";
import eye from "../../../assets/icons/eye.svg";
import { registerNewAccountAction } from "../Actions/CommonActions";
import BaseButton from "../Common/Buttons/BaseButton";
import { isVodexLoggedin, LoadingSlides } from "../CommonComponents/Common";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import ErrorPopUp from "../CommonComponents/PopUpCards/ErrorPopUp";
import CommonPopup from "../CommonComponents/PopUpCards/CommonPopup";
import { ReactComponent as SuccessIcon } from "../../../assets/Images/SuccessProjectIcon.svg";

const SignUp = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const reducer = useSelector((reducer: any) => reducer);
  const {
    AccountReducer: { whitelabelDetails },
  } = reducer;

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });

  const [errorObj, setErrorObj] = useState({
    show: false,
    errMsg: "",
  });
  const [successPopup, setSuccessPopup] = useState(false);

  const [signUpData, setSignUpData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    agree: false,
    url: "",
  });
  const [msg, setMsg] = useState("");
  const [spin, setSpin] = useState(false);
  const { email, password, confirmPassword, agree, url, firstName, lastName } =
    signUpData;

  useEffect(() => {
    const init = async () => {
      let url = whitelabelDetails?.termUrl ?? "";

      setSignUpData((prev) => ({
        ...prev,
        url: url,
      }));
    };
    init();
  }, [whitelabelDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpData((prev) => ({ ...prev, [name]: value }));
    setMsg("");
  };

  const handleTogglePassword = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleSignUp = async (e) => {
    setSpin(true);
    e.preventDefault();
    setMsg("");

    if (!email || !password || !confirmPassword || !firstName || !lastName) {
      setMsg(`Please fill all the fields`);
      setSpin(false);
      return;
    }

    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[!@#$%^&*()_+[\]{}|\\:;'"<>,.?/~`]/.test(password)
    ) {
      if (password === confirmPassword) {
        if (!agree) {
          setMsg(`Please accept terms and conditions.`);
          setSpin(false);

          return;
        }
        let obj = {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          email: email.trim(),
          password: password,
          confirmPassword: confirmPassword,
        };

        let res: any = await dispatch(registerNewAccountAction(obj));

        if (res?.status !== 200) {
          setErrorObj({
            show: true,
            errMsg: res?.errMsg,
          });
          setSpin(false);
          return;
        }
        if (res?.status === 200) {
          setSuccessPopup(true);
          setTimeout(() => {
            history.push("/");
          }, 3000);
        }
      } else {
        setMsg(`Password doesn't match `);
        setSpin(false);
        return;
      }
    } else {
      setMsg(
        " Password must be at least 8 characters must contain an uppercase, lowercase,numbers and special characters"
      );
    }
    setSpin(false);
  };

  return (
    <Box className="main-container">
      <Typography
        sx={{
          color: "#656E7F",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        Welcome!
      </Typography>
      <Typography
        className="font-28-700-grey"
        sx={{
          mb: 1,
        }}
      >
        Sign Up to get started!
      </Typography>
      <Box className="flex-align-center" gap={1} mb={2}>
        <Box width={1 / 2}>
          <Typography className="font-14-grey, mb-1">First Name</Typography>
          <TextField
            type="text"
            name="firstName"
            value={firstName}
            required={true}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter your First Name"
            sx={commonStyles.inputField}
          />
        </Box>
        <Box width={1 / 2}>
          <Typography className="font-14-grey, mb-1">Last Name</Typography>
          <TextField
            type="text"
            name="lastName"
            value={lastName}
            required={true}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter your Last Name"
            sx={commonStyles.inputField}
          />
        </Box>
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Typography className="font-14-grey, mb-1">Email</Typography>
        <TextField
          type="email"
          name="email"
          value={email?.toLowerCase()}
          required={true}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="Enter your email"
          sx={commonStyles.inputField}
        />
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Typography className="font-14-grey, mb-1">Password</Typography>
        <TextField
          type={showPassword.password ? "text" : "password"}
          required={true}
          name="password"
          value={password}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="Enter your password"
          sx={commonStyles.inputField}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePassword("password")}
                    edge="end"
                    sx={{ padding: "0", marginRight: 1.5 }}
                    disableRipple
                    disableFocusRipple
                    style={{ outline: "none" }}
                  >
                    <img
                      src={showPassword.password ? eyeSlash : eye}
                      alt="password visibility"
                    />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Typography className="font-14-grey, mb-1">Confirm Password</Typography>
        <TextField
          type={showPassword.confirmPassword ? "text" : "password"}
          required={true}
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          placeholder="Confirm your password"
          sx={commonStyles.inputField}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePassword("confirmPassword")}
                    edge="end"
                    sx={{ padding: "0", marginRight: 1.5, outline: "none" }}
                    disableRipple
                    disableFocusRipple
                  >
                    <img
                      src={showPassword.confirmPassword ? eyeSlash : eye}
                      alt="password visibility"
                    />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
      {msg && (
        <Typography sx={{ color: "red", textAlign: "center", my: 1 }}>
          {msg}
        </Typography>
      )}
      <Box className="flex-xy-center">
        <Checkbox
          name="agree"
          checked={agree}
          onChange={() => {
            setSignUpData((prev) => ({ ...prev, agree: !agree }));
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: 20,
            },
          }}
        />
        <Typography
          className="font-14-400-grey"
          sx={{
            textAlign: "left",
            my: 1,
            pr: 2,
          }}
        >
          By continuing you agree to Vodex{" "}
          <a target="_blank" href={"https://www.vodex.ai/terms-of-use"}>
            <span style={{ color: "#4280FF" }}>Terms of Service</span>
          </a>{" "}
          and{" "}
          <a target="_blank" href={"https://www.vodex.ai/privacy-policy"}>
            <span style={{ color: "#4280FF" }}>Privacy Policy</span>
          </a>
        </Typography>
      </Box>
      <Button
        onClick={handleSignUp}
        disabled={spin}
        variant="contained"
        sx={commonStyles.loginButton}
        fullWidth
      >
        {spin ? <LoadingSlides bgColor="white" /> : "Sign Up"}
      </Button>
      <Box
        className="flex-row-center"
        sx={{
          mt: 2,
        }}
      >
        <BaseButton
          title="Go Back to login"
          handleClick={() => history.push("/")}
          startIcon={<ArrowBackIcon />}
          styles={{ color: "#1A1D23", fontSize: 14, fontWeight: 400 }}
        />
      </Box>

      <CommonPopup
        message={
          "Verification Email has been sent to your Email Id, Please verify to continue, if not received please check once on spam folder"
        }
        show={successPopup}
        toggle={() => {
          history.push("/");
          setSuccessPopup((prev) => !prev);
        }}
        Icon={SuccessIcon}
        heading="Email Sent"
      />
      <ErrorPopUp
        show={errorObj.show}
        toggle={() =>
          setErrorObj((prev) => ({
            ...prev,
            show: false,
            errMsg: "",
          }))
        }
        heading={"Error"}
        message={errorObj?.errMsg}
        spin={spin}
      />
    </Box>
  );
};

export default SignUp;
